module.exports = __webpack_public_path__ + "static/media/barberscape-replacement-blade-2.d290524b.png";